import { Divider } from '@/components/divider';
import { FC } from 'react';
import { SidebarBase } from '../common';
import { SIDEBAR_CONFIG } from '../common/constants';
import { ExternalSidebarClassNames } from './ExternalSidebar.styles';

type SidebarNavigationProps = {
  className?: string;
};

export const ExternalSidebarNavigation: FC<SidebarNavigationProps> = ({ className }) => {
  return (
    <SidebarBase.Navigation className={className}>
      {SIDEBAR_CONFIG.slice(0, 1).map((item) => (
        <SidebarBase.NavItem key={item.path} {...item} classNames={ExternalSidebarClassNames} />
      ))}
      <Divider dividerWrapperClassName='group-data-[expanded=false]/sidebar:hidden' />
      <div className='grow'>
        {SIDEBAR_CONFIG.slice(1).map((item) => (
          <SidebarBase.NavItem key={item.path} {...item} classNames={ExternalSidebarClassNames} />
        ))}
      </div>
      <SidebarBase.SettingsItem classNames={ExternalSidebarClassNames} />
      <SidebarBase.SupportItem classNames={ExternalSidebarClassNames} />
    </SidebarBase.Navigation>
  );
};
